import { render, staticRenderFns } from "./DefaultMappingCell.vue?vue&type=template&id=4149b6e3&scoped=true"
import script from "./DefaultMappingCell.vue?vue&type=script&lang=js"
export * from "./DefaultMappingCell.vue?vue&type=script&lang=js"
import style0 from "./DefaultMappingCell.vue?vue&type=style&index=0&id=4149b6e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4149b6e3",
  null
  
)

export default component.exports